// @vendors
import { useLocation } from 'react-router-dom';

// @types
import { UseUrlData } from '../types';

export function useUrlData(): UseUrlData {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const tenderNumber = parseInt(searchParams.get('tenderNumber'));
  const carrierId = parseInt(searchParams.get('carrierId'));
  const wasOfferProcessed = searchParams.get('accepted');
  const shouldBeBooked = !isNaN(parseInt(wasOfferProcessed))
    ? parseInt(wasOfferProcessed) === 1
    : null;

  return {
    carrierId,
    shouldBeBooked,
    tenderNumber
  };
}
